export const excursions = [
  // ─── EXISTING ───────────────────────────────────────────────────────────────
  {
    slug: "buggy-volcano",
    title: "Buggy Volcano Expedition — 3 Hours",
    subtitle: "Polaris RZR Off-Road Adventure Around Mount Teide",
    category: "Adventure & Nature",
    categoryKey: "cat_adventure_nature",
    duration: "3 hrs",
    rating: 4.9,
    reviewsCount: 128,
    priceFrom: 190,
    heroImage: "/images/excursions/buggy-volcano-hero.jpg",
    gallery: [
      "/images/excursions/buggy-volcano-g1.jpg",
      "/images/excursions/buggy-volcano-g2.jpg",
      "/images/excursions/buggy-volcano-g3.jpg",
      "/images/excursions/buggy-volcano-g4.jpg",
    ],
    tagline: "Ride the most powerful Polaris RZR buggies across volcanic trails on Tenerife.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c", "d", "e", "f"],
    requirements: ["a", "b"],
    recommendations: ["a", "b", "c"],
    languages: ["English", "Spanish"],
    variants: [
      { id: "single", label: "Single buggy", price: 190 },
      { id: "double", label: "Double buggy", price: 210 },
    ],
    location: "Los Abrigos, Tenerife South",
    meetingPoint: "Hotel pick-up available across South Tenerife",
    pickup: true,
    wheelchair: false,
  },
  {
    slug: "jungle-park",
    title: "Jungle Park Wildlife — Arona, Tenerife",
    subtitle: "Meet exotic wildlife, raptors and majestic big cats",
    category: "Theme Parks & Tickets",
    categoryKey: "cat_parks_tickets",
    duration: "4 - 5 hrs",
    rating: 4.8,
    reviewsCount: 342,
    priceFrom: 36,
    heroImage: "/images/excursions/jungle-park-hero.jpg",
    gallery: [
      "/images/excursions/jungle-park-g1.jpg",
      "/images/excursions/jungle-park-g2.jpg",
      "/images/excursions/jungle-park-g3.jpg",
      "/images/excursions/jungle-park-g4.jpg",
      "/images/excursions/jungle-park-g5.jpg",
      "/images/excursions/jungle-park-g6.jpg",
    ],
    tagline:
      "A different kind of zoo focused on jungle wildlife: birds of prey, falcons, eagles and exotic animals of every kind.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["English", "Spanish", "German", "French", "Italian", "Dutch", "Russian"],
    variants: [
      { id: "adult", label: "Adult ticket", price: 36 },
      { id: "child", label: "Child (5 – 10 yrs)", price: 29 },
      { id: "infant", label: "Infant (3 – 4 yrs)", price: 16 },
    ],
    location: "Arona, Tenerife South",
    meetingPoint: "Free bus service from Los Cristianos, Las Américas, Costa Adeje",
    pickup: false,
    wheelchair: true,
    schedule: [
      { name: "Exotic Birds Show", time: "11:00 & 14:30" },
      { name: "Birds of Prey", time: "12:00 & 16:00" },
      { name: "Sea Lions Show", time: "13:45 & 15:15" },
      { name: "Penguins Feeding", time: "12:45" },
    ],
  },
  {
    slug: "twin-ticket",
    title: "Twin Ticket — Loro Parque + Siam Park",
    subtitle: "Two of the best theme parks in the world in a single ticket",
    category: "Theme Parks & Tickets",
    categoryKey: "cat_parks_tickets",
    duration: "5 hrs",
    rating: 4.7,
    reviewsCount: 512,
    priceFrom: 78,
    heroImage: "/images/excursions/twin-ticket-hero.jpg",
    gallery: [
      "/images/excursions/twin-ticket-g1.jpg",
      "/images/excursions/twin-ticket-g2.jpg",
      "/images/excursions/twin-ticket-g3.jpg",
      "/images/excursions/twin-ticket-g4.jpg",
      "/images/excursions/twin-ticket-g5.jpg",
      "/images/excursions/twin-ticket-g6.jpg",
    ],
    tagline:
      "Combined ticket to visit Loro Parque and Siam Park — voted best zoo and best water park in the world by TripAdvisor users.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c"],
    requirements: ["a"],
    recommendations: ["a", "b"],
    languages: ["English", "Spanish", "German", "French", "Italian", "Dutch", "Russian"],
    variants: [
      { id: "twin", label: "Twin Ticket Adult", price: 78, child: 57, infant: 0 },
      { id: "twin-resident", label: "Twin Ticket Resident", price: 39, child: 28, infant: 0 },
      { id: "twin-bus", label: "Twin Ticket + Bus to Loro Parque", price: 99, child: 74, infant: 19 },
      { id: "transfer-loro", label: "Transfer to Loro Parque", price: 23, child: 19, infant: 19 },
      { id: "transfer-siam", label: "Transfer Siam Bus from Puerto de la Cruz", price: 26, child: 22, infant: 22 },
    ],
    location: "Puerto de la Cruz & Costa Adeje, Tenerife",
    meetingPoint: "Free bus service across South Tenerife",
    pickup: true,
    wheelchair: true,
    hours: [
      { park: "Loro Parque", info: "8:30 – 18:45, 365 days a year" },
      { park: "Siam Park (May–Oct)", info: "10:00 – 18:00" },
      { park: "Siam Park (Nov–Apr)", info: "10:00 – 17:00" },
    ],
  },

  // ─── NEW ────────────────────────────────────────────────────────────────────
  {
    slug: "two-parks-ticket",
    title: "Two Parks Ticket — Jungle Park + Aqualand",
    subtitle: "Visit two incredible theme parks in one day",
    category: "Theme Parks & Tickets",
    categoryKey: "cat_parks_tickets",
    duration: "6 hrs",
    rating: 4.8,
    reviewsCount: 42,
    priceFrom: 53,
    heroImage: "/images/excursions/two-parks-hero.jpg",
    gallery: [
      "/images/excursions/two-parks-g1.jpg",
      "/images/excursions/two-parks-g2.jpg",
      "/images/excursions/two-parks-g3.jpg",
    ],
    tagline: "Enjoy two of Tenerife best theme parks with one combined ticket.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["English", "Spanish", "German", "French", "Italian", "Dutch", "Russian"],
    variants: [
      { id: "adult", label: "Adult ticket", price: 53 },
      { id: "child", label: "Child ticket", price: 40 },
    ],
    location: "Arona & Costa Adeje, Tenerife",
    meetingPoint: "Own transport required",
    pickup: false,
    wheelchair: true,
  },
  {
    slug: "jeep-safari-la-gomera",
    title: "Jeep Safari — La Gomera Island",
    subtitle: "Discover the wild nature and scenic roads of La Gomera by 4x4",
    category: "Adventure & Nature",
    categoryKey: "cat_adventure_nature",
    duration: "9 hrs",
    rating: 4.8,
    reviewsCount: 45,
    priceFrom: 150,
    heroImage: "/images/excursions/la-gomera-hero.jpg",
    gallery: [
      "/images/excursions/la-gomera-g1.jpg",
      "/images/excursions/la-gomera-g2.jpg",
      "/images/excursions/la-gomera-g3.jpg",
    ],
    tagline: "An unforgettable adventure through the picturesque roads of La Gomera.",
    highlights: ["a", "b", "c", "d", "e"],
    included: ["a", "b", "c", "d", "e"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "adult-south", label: "Adult (South)", price: 150 },
      { id: "child-south", label: "Child 2-11 yrs (South)", price: 120 },
      { id: "adult-north", label: "Adult (North)", price: 165 },
      { id: "child-north", label: "Child 2-11 yrs (North)", price: 135 },
    ],
    location: "La Gomera Island",
    meetingPoint: "Costa Adeje, Los Cristianos, Las Americas, Callao Salvaje, Playa Paraiso, Golf del Sur, Los Gigantes, Puerto Santiago, Puerto de La Cruz",
    pickup: true,
    wheelchair: false,
  },
  {
    slug: "helicopter-flights",
    title: "Helicopter Scenic Flights — Tenerife",
    subtitle: "See Tenerife from above — 5 stunning routes to choose from",
    category: "Adventure & Nature",
    categoryKey: "cat_adventure_nature",
    duration: "8 – 50 min",
    rating: 4.9,
    reviewsCount: 38,
    priceFrom: 98,
    heroImage: "/images/excursions/helicopter-hero.jpg",
    gallery: [
      "/images/excursions/helicopter-g1.jpg",
      "/images/excursions/helicopter-g2.jpg",
      "/images/excursions/helicopter-g3.jpg",
    ],
    tagline: "Discover Tenerife from a completely new perspective with breathtaking helicopter scenic flights.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b"],
    requirements: ["a"],
    recommendations: ["a"],
    languages: ["English", "Spanish"],
    variants: [
      { id: "south-coast", label: "South Coast 8-9 min", price: 98 },
      { id: "beaches-canyons", label: "Beaches & Canyons 12-15 min", price: 145 },
      { id: "beaches-cliffs", label: "Beaches, Canyons & Cliffs 20-22 min", price: 279 },
      { id: "beaches-cliffs-teno", label: "Beaches, Canyons, Cliffs & Teno 35-40 min", price: 390 },
      { id: "teide", label: "Teide & Surroundings 45-50 min", price: 495 },
    ],
    location: "South Tenerife",
    meetingPoint: "Heliport South Tenerife",
    pickup: false,
    wheelchair: false,
  },
  {
    slug: "catamaran-dolphin-watching",
    title: "Catamaran Dolphin & Whale Watching — 4.5 hrs",
    subtitle: "Sail along the stunning western coast and search for dolphins and whales",
    category: "Boat Trips",
    categoryKey: "cat_boat_trips",
    duration: "4.5 hrs",
    rating: 4.8,
    reviewsCount: 93,
    priceFrom: 62,
    heroImage: "/images/excursions/catamaran-hero.jpg",
    gallery: [
      "/images/excursions/catamaran-g1.jpg",
      "/images/excursions/catamaran-g2.jpg",
      "/images/excursions/catamaran-g3.jpg",
    ],
    tagline: "A unique 4.5-hour catamaran trip along the coast of Tenerife with dolphins in their natural habitat.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "adult-south", label: "Adult (South)", price: 62 },
      { id: "child-south", label: "Child 5-11 yrs (South)", price: 42 },
    ],
    location: "Costa Adeje, South Tenerife",
    meetingPoint: "Hotels in south and north Tenerife — Tuesdays and Sundays",
    pickup: true,
    wheelchair: false,
  },
  {
    slug: "pirate-ship-los-gigantes",
    title: "Pirate Ship Dolphin Watching — Los Gigantes",
    subtitle: "3-hour adventure from Los Gigantes port on the legendary Flipper Uno pirate ship",
    category: "Boat Trips",
    categoryKey: "cat_boat_trips",
    duration: "3 hrs",
    rating: 4.7,
    reviewsCount: 67,
    priceFrom: 40,
    heroImage: "/images/excursions/pirate-ship-hero.jpg",
    gallery: [
      "/images/excursions/pirate-ship-g1.jpg",
      "/images/excursions/pirate-ship-g2.jpg",
      "/images/excursions/pirate-ship-g3.jpg",
    ],
    tagline: "Board the legendary wooden pirate ship Flipper Uno for dolphin watching, swimming and on-board lunch.",
    highlights: ["a", "b", "c", "d"],
    included: ["a"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "adult", label: "Adult", price: 40 },
      { id: "child", label: "Child 2-11 yrs", price: 25 },
      { id: "infant", label: "Infant 0-2 yrs", price: 0 },
    ],
    location: "Los Gigantes Port, West Tenerife",
    meetingPoint: "Puerto de Los Gigantes",
    pickup: false,
    wheelchair: false,
  },
  {
    slug: "night-skies-tenerife",
    title: "Night Skies Tenerife — Stargazing at Teide",
    subtitle: "Stargaze with telescopes in the incredible night sky of Teide National Park",
    category: "Adventure & Nature",
    categoryKey: "cat_adventure_nature",
    duration: "3 – 4 hrs",
    rating: 4.5,
    reviewsCount: 18,
    priceFrom: 55,
    heroImage: "/images/excursions/night-skies-hero.jpg",
    gallery: [
      "/images/excursions/night-skies-g1.jpg",
      "/images/excursions/night-skies-g2.jpg",
      "/images/excursions/night-skies-g3.jpg",
    ],
    tagline: "Stargaze from the Teide National Park with high-power telescopes and expert astronomy guides.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b"],
    requirements: ["a", "b"],
    recommendations: ["a"],
    languages: ["English", "Spanish", "German", "Dutch", "Chinese"],
    variants: [
      { id: "sunset-self-drive", label: "Sunset & Stars — Self Drive", price: 55 },
      { id: "star-safari-no-dinner", label: "Star Safari (No Dinner)", price: 55 },
      { id: "star-safari-dinner", label: "Star Safari (Dinner Included)", price: 75 },
    ],
    location: "Teide National Park, Tenerife",
    meetingPoint: "Hotel pick-up available from South Tenerife",
    pickup: true,
    wheelchair: false,
  },
  {
    slug: "ole-flamenco-show",
    title: "Olé Flamenco Show — Costa Adeje",
    subtitle: "An evening of Spanish dance, passion and colour at Hotel GF Victoria",
    category: "Entertainment",
    categoryKey: "cat_entertainment",
    duration: "2 hrs",
    rating: 4.0,
    reviewsCount: 14,
    priceFrom: 51,
    heroImage: "/images/excursions/flamenco-hero.jpg",
    gallery: [
      "/images/excursions/flamenco-g1.jpg",
      "/images/excursions/flamenco-g2.jpg",
      "/images/excursions/flamenco-g3.jpg",
    ],
    tagline: "A spectacular performance of light, colour and force — a journey through Spanish dance by Fran Chafino.",
    highlights: ["a", "b", "c", "d"],
    included: ["a"],
    requirements: ["a"],
    recommendations: ["a", "b"],
    languages: ["Spanish"],
    variants: [
      { id: "oro-adult", label: "Oro — Adult", price: 51 },
      { id: "oro-child", label: "Oro — Child (3-11 yrs)", price: 25 },
      { id: "platino-adult", label: "Platino — Adult", price: 61 },
      { id: "platino-child", label: "Platino — Child (3-11 yrs)", price: 30 },
    ],
    location: "Hotel GF Victoria, Costa Adeje",
    meetingPoint: "Hotel GF Victoria, Costa Adeje — reception at 20:30",
    pickup: false,
    wheelchair: true,
  },
  {
    slug: "jet-ski-los-gigantes",
    title: "Jet Ski Los Gigantes — Blue Safari",
    subtitle: "Guided jet ski tour from Los Gigantes to Punta de Teno with two stops",
    category: "Water Activities",
    categoryKey: "cat_water_activities",
    duration: "1 hr",
    rating: 4.8,
    reviewsCount: 24,
    priceFrom: 130,
    heroImage: "/images/excursions/jet-ski-hero.jpg",
    gallery: [
      "/images/excursions/jet-ski-g1.jpg",
      "/images/excursions/jet-ski-g2.jpg",
      "/images/excursions/jet-ski-g3.jpg",
    ],
    tagline: "A guided jet ski safari along the wildest coastline of Tenerife from Los Gigantes to Punta de Teno.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c", "d", "e", "f", "g", "h"],
    requirements: ["a", "b", "c", "d"],
    recommendations: [],
    languages: ["English", "Spanish"],
    variants: [
      { id: "individual", label: "Individual jet ski", price: 130 },
      { id: "double", label: "Double jet ski", price: 140 },
    ],
    location: "Puerto de Los Gigantes, West Tenerife",
    meetingPoint: "Puerto de Los Gigantes",
    pickup: false,
    wheelchair: false,
  },
  {
    slug: "vip-tour-tenerife",
    title: "VIP Private Tour — Tenerife",
    subtitle: "Discover the real Tenerife at your own pace with a private guide",
    category: "Adventure & Nature",
    categoryKey: "cat_adventure_nature",
    duration: "8 hrs",
    rating: 5.0,
    reviewsCount: 27,
    priceFrom: 200,
    heroImage: "/images/excursions/vip-tour-hero.jpg",
    gallery: [
      "/images/excursions/vip-tour-g1.jpg",
      "/images/excursions/vip-tour-g2.jpg",
      "/images/excursions/vip-tour-g3.jpg",
    ],
    tagline: "Discover Tenerife in exclusive VIP style — no strangers, no rush, no fixed schedules. Travel at your own pace with full freedom of stops and a flexible route that reveals the real face of the island.",
    highlights: ["a", "b", "c", "d", "e"],
    included: ["a", "b"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "2-people", label: "2 people", price: 200 },
      { id: "3-people", label: "3 people", price: 270 },
      { id: "4-people", label: "4 people", price: 330 },
      { id: "5-plus", label: "5+ people", price: 390 },
    ],
    location: "Tenerife (island-wide)",
    meetingPoint: "Pick-up from any location on the island",
    pickup: true,
    wheelchair: false,
  },
  {
    slug: "paragliding-tenerife",
    title: "Paragliding Tenerife — 3 Packages",
    subtitle: "Tandem paragliding flights above the Atlantic coast — Bronze, Silver & Acrobatic",
    category: "Adventure & Nature",
    categoryKey: "cat_adventure_nature",
    duration: "10 – 40 min",
    rating: 5.0,
    reviewsCount: 47,
    priceFrom: 110,
    heroImage: "/images/excursions/paragliding-hero.webp",
    gallery: [
      "/images/excursions/paragliding-g1.webp",
      "/images/excursions/paragliding-g2.webp",
      "/images/excursions/paragliding-g3.jpg",
    ],
    tagline: "Three packages to suit every taste — from a first-timer’s gentle glide to full-on aerobatic manoeuvres over the ocean.",
    highlights: ["a", "b", "c", "d", "e"],
    included: ["a", "b", "c"],
    requirements: ["a", "b"],
    recommendations: ["a", "b"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "bronze", label: "Bronze — 10-20 min", price: 110 },
      { id: "silver", label: "Silver — 20-40 min", price: 130 },
      { id: "acrobatic", label: "Acrobatic — max altitude", price: 140 },
      { id: "photo-pack", label: "+ Photo & Video Pack (any flight)", price: 30 },
    ],
    location: "El Médano / Ifonche, Tenerife",
    meetingPoint: "El Médano beach area — exact meeting point confirmed on booking",
    pickup: false,
    wheelchair: false,
  },
  {
    slug: "kayak-los-gigantes",
    title: "Kayak Los Gigantes — Cliffs & Ocean",
    subtitle: "Explore the majestic Los Gigantes cliffs by kayak — a raw ocean experience",
    category: "Water Activities",
    categoryKey: "cat_water_activities",
    duration: "2 hrs",
    rating: 4.9,
    reviewsCount: 31,
    priceFrom: 35,
    heroImage: "/images/excursions/kayak-hero.jpg",
    gallery: [
      "/images/excursions/kayak-g1.jpg",
      "/images/excursions/kayak-g2.jpg",
      "/images/excursions/kayak-g3.jpg",
    ],
    tagline: "Explore the majestic Acantilados de Los Gigantes at your own pace on a guided kayak adventure.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c", "d"],
    requirements: ["a", "b"],
    recommendations: [],
    languages: ["English", "Spanish"],
    variants: [
      { id: "adult", label: "Adult — 13:00 session", price: 35 },
      { id: "child", label: "Child (6-9 yrs) — 13:00 session", price: 15 },
    ],
    location: "Los Gigantes, West Tenerife",
    meetingPoint: "Los Gigantes port — boat transfer to kayaking area",
    pickup: false,
    wheelchair: false,
  },
  // ─── Aqualand ─────────────────────────────────────────────────────────────
  {
    slug: "aqualand-costa-adeje",
    title: "Aqualand Costa Adeje — Park Wodny",
    subtitle: "Największy park wodny na południu Teneryfy z własnym delfinarium",
    category: "Theme Parks & Tickets",
    categoryKey: "cat_parks_tickets",
    duration: "4 – 5 hrs",
    rating: 4.7,
    reviewsCount: 89,
    priceFrom: 37,
    heroImage: "/images/excursions/aqualand-hero.jpg",
    gallery: [
      "/images/excursions/aqualand-g2.jpg",
      "/images/excursions/aqualand-g3.jpg",
    ],
    tagline: "Park wodny z własnym delfinarium, atrakcjami wodnymi i spektaklem delfinów.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["English", "Spanish", "German", "French", "Italian", "Dutch"],
    variants: [
      { id: "adult", label: "Bilet dorosły", price: 37 },
      { id: "child", label: "Dziecko (5–10 lat)", price: 29 },
      { id: "infant", label: "Niemowlę (3–4 lata)", price: 16 },
    ],
    location: "Costa Adeje, Tenerife South",
    meetingPoint: "Free bus from Los Cristianos, Las Américas and Costa Adeje",
    pickup: false,
    wheelchair: true,
  },
  // ─── Siam Park ───────────────────────────────────────────────────────────────
  {
    slug: "siam-park-tenerife",
    title: "Siam Park — Najlepszy Park Wodny Świata",
    subtitle: "7 razy z rzędu najlepszy park wodny świata według TripAdvisor",
    category: "Theme Parks & Tickets",
    categoryKey: "cat_parks_tickets",
    duration: "5 hrs",
    rating: 4.7,
    reviewsCount: 312,
    priceFrom: 48,
    heroImage: "/images/excursions/siam-park-hero-v2.jpg",
    gallery: [
      "/images/excursions/siam-park-g1-v2.jpg",
      "/images/excursions/siam-park-g2-v2.jpg",
      "/images/excursions/siam-park-g3-v2.jpg",
    ],
    tagline: "Park wodny z tajską tematyką w Costa Adeje — Tower of Power, Singha i 13 000 m² plaży.",
    highlights: ["a", "b", "c", "d"],
    included: ["a"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["English", "Spanish", "German", "French", "Italian", "Dutch", "Russian"],
    variants: [
      { id: "adult", label: "Bilet dorosły", price: 48, child: 36, infant: 0 },
      { id: "resident", label: "Bilet rezydent", price: 24, child: 17, infant: 0 },
      { id: "transfer-north", label: "Transfer z Puerto de la Cruz", price: 26, child: 22, infant: 22 },
    ],
    location: "Costa Adeje, Tenerife South",
    meetingPoint: "Free bus service from multiple south Tenerife locations",
    pickup: true,
    wheelchair: true,
    hours: [
      { park: "Lato", info: "10:00 – 18:00" },
      { park: "Zima", info: "10:00 – 17:00" },
    ],
  },
  // ─── Loro Parque ─────────────────────────────────────────────────────────────
  {
    slug: "loro-parque-tenerife",
    title: "Loro Parque — Najlepsze ZOO Świata",
    subtitle: "Sanktuarium przyrody z 400 gatunkami zwierząt i spektaklami orek, delfinów i papug",
    category: "Theme Parks & Tickets",
    categoryKey: "cat_parks_tickets",
    duration: "5 hrs",
    rating: 4.6,
    reviewsCount: 478,
    priceFrom: 44,
    heroImage: "/images/excursions/loro-parque-hero.jpg",
    gallery: [
      "/images/excursions/loro-parque-g1.jpg",
      "/images/excursions/loro-parque-g2.jpg",
      "/images/excursions/loro-parque-g3.jpg",
    ],
    tagline: "Loro Parque to nie tylko zoo — to sanktuarium poświęcone ochronie przyrody z unikalnymi spektaklami i 400+ gatunkami zwierząt.",
    highlights: ["a", "b", "c", "d"],
    included: ["a"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["English", "Spanish", "German", "French", "Italian", "Dutch", "Russian"],
    variants: [
      { id: "adult", label: "Bilet dorosły", price: 44, child: 32, infant: 0 },
      { id: "resident", label: "Bilet rezydent", price: 22, child: 16, infant: 0 },
      { id: "bus", label: "Bilet + autobus", price: 65, child: 49, infant: 19 },
      { id: "transfer", label: "Transfer", price: 23, child: 19, infant: 19 },
    ],
    location: "Puerto de la Cruz, Tenerife North",
    meetingPoint: "Pick-up from South Tenerife hotels available",
    pickup: true,
    wheelchair: true,
    schedule: [
      { name: "Pokaz Lwów Morskich", time: "09:45 | 10:45 | 13:45 | 14:45" },
      { name: "Loro Show (papugi)", time: "10:25 | 12:30 | 14:30 | 15:30 | 16:45" },
      { name: "Pokaz Delfinów", time: "11:00 | 13:00 | 16:15" },
      { name: "Pokaz Orek", time: "11:55 | 15:15" },
    ],
  },
  // ─── Castillo San Miguel ──────────────────────────────────────────────────────
  {
    slug: "castillo-san-miguel",
    title: "Castillo San Miguel — Wieczór Średniowieczny",
    subtitle: "Autentyczny turniej rycerski z ucztą średniowieczną w zamku hrabiego Don Rodrigo",
    category: "Entertainment",
    categoryKey: "cat_entertainment",
    duration: "3 hrs",
    rating: 4.3,
    reviewsCount: 47,
    priceFrom: 52,
    heroImage: "/images/excursions/castillo-hero.jpg",
    gallery: [
      "/images/excursions/castillo-g1.jpg",
      "/images/excursions/castillo-g2.jpg",
      "/images/excursions/castillo-g3.jpg",
    ],
    tagline: "Wróć do średniowiecza — turnieje rycerskie, uczta przy blasku pochodni i wielka arena w zamku Don Rodrigo.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b"],
    requirements: ["a"],
    recommendations: ["a", "b"],
    languages: ["English", "Spanish", "German", "French", "Italian"],
    variants: [
      { id: "show-dinner", label: "Pokaz + Kolacja", price: 52, child: 31, infant: 0 },
      { id: "show-dinner-vip", label: "Pokaz + Kolacja VIP", price: 63, child: 37, infant: 0 },
      { id: "show-dinner-transfer", label: "Pokaz + Kolacja + Transfer", price: 68, child: 42, infant: 11 },
    ],
    location: "Castillo San Miguel, San Miguel de Abona, Tenerife",
    meetingPoint: "Hotel pick-up from South Tenerife — Tue, Thu & Sat evenings",
    pickup: true,
    wheelchair: false,
  },
  {
    slug: "yacht-cruise-puerto-colon",
    title: "Yacht Cruise — 3 Hours from Puerto Colón",
    subtitle: "Exclusive 3-hour yacht cruise with drinks, dolphin watching and a swim stop",
    category: "Boat Trips",
    categoryKey: "cat_boat_trips",
    duration: "3 hrs",
    rating: 5.0,
    reviewsCount: 19,
    priceFrom: 70,
    heroImage: "/images/excursions/yacht-hero.jpg",
    gallery: [
      "/images/excursions/yacht-g1.jpg",
      "/images/excursions/yacht-g2.jpg",
      "/images/excursions/yacht-g3.jpg",
      "/images/excursions/yacht-g4.jpg",
    ],
    tagline: "Sail the Atlantic in style — dolphin spotting, a secluded beach stop and drinks included, with just 11 people max on board.",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c"],
    requirements: [],
    recommendations: ["a", "b"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "adult", label: "Adult", price: 70 },
    ],
    location: "Puerto Colón, Costa Adeje",
    meetingPoint: "Puerto Colón marina — exact berth confirmed on booking",
    pickup: false,
    wheelchair: false,
  },
  // ─── Sea Fishing Trip ────────────────────────────────────────────────────────
  {
    slug: "sea-fishing-tenerife",
    title: "Morska Wyprawa Wędkarska — Teneryfa",
    subtitle: "Cała łódź tylko dla Was — wędkarstwo morskie z południa Teneryfy",
    category: "Boat Trips",
    categoryKey: "cat_boat_trips",
    duration: "3 – 4 hrs",
    rating: 4.9,
    reviewsCount: 8,
    priceFrom: 360,
    heroImage: "/images/excursions/sea-fishing-hero.webp",
    gallery: [
      "/images/excursions/sea-fishing-g1.webp",
      "/images/excursions/sea-fishing-g2.webp",
      "/images/excursions/sea-fishing-g3.webp",
    ],
    imageFilter: "saturate(1.15) contrast(1.06) brightness(1.03)",
    tagline: "Wskakujcie na pokład i spędźcie niezapomniane godziny na morzu. Cała łódź tylko dla Was, maksymalnie 4 osoby, 120 € za godzinę. Idealna opcja dla rodziny, paczki znajomych albo małej grupy wędkarzy. Nie liczy się doświadczenie — liczy się dobra zabawa, morze i emocje na pokładzie!",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c", "d"],
    requirements: ["a"],
    recommendations: ["a", "b"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "3-hours", label: "3 godziny", price: 360 },
      { id: "4-hours", label: "4 godziny", price: 480 },
    ],
    location: "South Tenerife",
    meetingPoint: "Port południowej Teneryfy — dokładne miejsce potwierdzane przy rezerwacji",
    pickup: false,
    wheelchair: false,
  },
  // ─── Anaga Mountain Hike ───────────────────────────────────────────────
  {
    slug: "anaga-mountain-hike",
    title: "Wędrówka po magicznych górach Anaga",
    subtitle: "Krótka, intensywna wędrówka przez tajemniczy las laurowy i spektakularne widoki",
    category: "Adventure & Nature",
    categoryKey: "cat_adventure_nature",
    duration: "2,5 – 3 godz.",
    rating: 4.9,
    reviewsCount: 6,
    priceFrom: 95,
    heroImage: "https://storage.helloreaddy.io/project_files/c12e9cee-0bde-4f0b-bb11-c2a2e0974bf4/44e39e6a-842b-4cd6-9634-31090ff4ee8e_compressed_IMG-20260811-WA0009.webp",
    gallery: [
      "https://storage.helloreaddy.io/project_files/c12e9cee-0bde-4f0b-bb11-c2a2e0974bf4/832e48e5-68e6-4b88-8ffc-69d97eefcfca_compressed_IMG-20260811-WA0008.webp",
      "https://storage.helloreaddy.io/project_files/c12e9cee-0bde-4f0b-bb11-c2a2e0974bf4/99d2e382-3f34-4096-a20e-24ece8a8d3c3_compressed_IMG-20260811-WA0011.webp",
      "https://storage.helloreaddy.io/project_files/c12e9cee-0bde-4f0b-bb11-c2a2e0974bf4/ae47a37c-601f-4656-acc5-5f068bad71ef_compressed_IMG-20260811-WA0012.webp",
      "https://storage.helloreaddy.io/project_files/c12e9cee-0bde-4f0b-bb11-c2a2e0974bf4/f16a24b9-a9bc-4f22-9531-dd0f6f85de38_compressed_IMG-20260811-WA0010.webp",
      "https://storage.helloreaddy.io/project_files/c12e9cee-0bde-4f0b-bb11-c2a2e0974bf4/e37a084b-d3cd-472b-900c-ed872c41a812_compressed_IMG-20260811-WA0013.webp",
    ],
    tagline: "Wyruszamy w kameralnej grupie i odkrywamy jedno z najbardziej niezwykłych miejsc Teneryfy. Czeka na Ciebie tajemniczy las laurowy, mgła unosząca się między paprociami i spektakularne widoki na doliny i wąwozy. To krótka, intensywna dawka natury, która zostaje w pamięci na długo!",
    highlights: ["a", "b", "c", "d"],
    included: ["a", "b", "c"],
    requirements: ["a", "b"],
    recommendations: ["a", "b", "c"],
    languages: ["Polish", "English", "Spanish"],
    variants: [
      { id: "person", label: "Osoba (min. 3 osoby)", price: 95 },
    ],
    location: "Anaga, Północna Teneryfa",
    meetingPoint: "Park Wiejski Anaga — dokładne miejsce potwierdzane przy rezerwacji",
    pickup: false,
    wheelchair: false,
  },
];

export const reviews = [
  {
    id: 1,
    excursion: "buggy-volcano",
    author: "Emma T.",
    date: "12/06/2025",
    rating: 5,
    title: "Absolute adrenaline rush!",
    body: "Best day of our Tenerife holiday. Our guide was hilarious and the volcanic landscape is unreal. The Polaris RZR is a beast — highly recommend!",
  },
  {
    id: 2,
    excursion: "jungle-park",
    author: "Marlene W.",
    date: "12/11/2024",
    rating: 5,
    title: "Best park we've visited",
    body: "It's the best park I've been to, well worth the money. Very clean, animals were amazing, food was really good. A great day out!",
  },
  {
    id: 3,
    excursion: "twin-ticket",
    author: "Melanie V.",
    date: "15/07/2025",
    rating: 5,
    title: "Great combo deal",
    body: "Yani helped us book — very kind and helpful. The combo ticket was great value and we had so much fun at both parks.",
  },
  {
    id: 4,
    excursion: "jungle-park",
    author: "Ruth A.",
    date: "11/07/2024",
    rating: 5,
    title: "Great customer service",
    body: "The staff were extremely helpful in every way, had a great trip, would recommend booking through them for trips out.",
  },
  {
    id: 5,
    excursion: "twin-ticket",
    author: "Ivan S.",
    date: "25/10/2024",
    rating: 5,
    title: "Everything was perfect!",
    body: "Everything ran smoothly, from the transfer to the entrance. Both parks are world class — Siam Park especially blew our minds.",
  },
  {
    id: 6,
    excursion: "buggy-volcano",
    author: "David K.",
    date: "22/08/2025",
    rating: 5,
    title: "Volcanic terrain is stunning",
    body: "Riding through the moon-like Teide landscape was surreal. The tapas & wine tasting afterwards was the perfect ending.",
  },
];